import { memo } from 'react';
import { default as css } from './RoundedIcon.module.scss';
import classNames from 'classnames';
import { RoundedIconProps } from './RoundedIcon.types';

/**
 * The `RoundedIcon` control adds a rounded background to the icon with specific
 * theme options and rounded background size styling.
 *
 * @param roundedBackgroundSize - {@link RoundedIconProps.roundedBackgroundSize roundedBackgroundSize} description.
 * @param themeType - {@link RoundedIconProps.themeType themeType} description.
 * @param landingPageStyle - {@link RoundedIconProps.landingPageStyle boolean} description.
 * @param allowInvertedPrimary - {@link RoundedIconProps.allowInvertedPrimary boolean} description.
 * @param children - {@link RoundedIconProps.children children} description.
 */
const RoundedIcon = memo(({
    roundedBackgroundSize,
    themeType,
    landingPageStyle,
    allowInvertedPrimary,
    children,
}: RoundedIconProps) => {
    return (
        <div
            role={'presentation'}
            className={classNames(
                css.roundedIcon,
                css[themeType],
                css[roundedBackgroundSize],
                allowInvertedPrimary && themeType === 'primary' && css.inverted,
                landingPageStyle && css.landingPageStyle,
            )}
        >
            {children}
        </div>
    );
});

export default RoundedIcon;
